import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Calendar from 'react-calendar';
import '../../styles/Calendar.css';
import '../../styles/DailyRecord.css';

const CalendarWithMarks = ({ dailyMarks = {}, weeklyMarks = {}, monthlyMarks = {}, onSelectDate }) => {
  const today = new Date();
  const todayStr = today.toLocaleDateString('sv-SE'); // YYYY-MM-DD形式

  const formatDate = (date) => {
    return date.toLocaleDateString('sv-SE');
  };

  const displayMonthMark = (activeStartDate) => {
    const firstOfMonth = new Date(activeStartDate.getFullYear(), activeStartDate.getMonth(), 1);
    const ymd = firstOfMonth.toISOString().split('T')[0];
    return monthlyMarks[ymd] ? ' ✅' : '';
  };

  return (
    <div className="calendar-with-header">
      <Calendar
        onClickDay={(date) => onSelectDate(date)}
        tileContent={({ date, view }) => {
          if (view !== 'month') return null;

          const dateStr = formatDate(date);
          const dots = [];

          if (date <= today) {
            if (dailyMarks[dateStr] === 'blue') {
              dots.push(<div key="d-blue" className="dot --blue" title="日報（記録済）" />);
            } else if (dailyMarks[dateStr] === 'red') {
              dots.push(<div key="d-red" className="dot --red" title="日報（未記録または不足）" />);
            }
            if (weeklyMarks[dateStr]) {
              dots.push(<div key="w-green" className="dot --green" title="週報記録済" />);
            }
          }
          return <div className="dot-container">{dots}</div>;
        }}
        tileClassName={({ date }) => {
          const dateStr = formatDate(date);
          const classes = [];
          if (dateStr === todayStr) classes.push('today');
          return classes.join(' ');
        }}
        formatMonthYear={(locale, date) => {
          const y = date.getFullYear();
          const m = date.getMonth() + 1;
          const firstOfMonth = new Date(y, date.getMonth(), 1).toISOString().split('T')[0];
          const mark = monthlyMarks[firstOfMonth] ? ' ✅' : '';
          return `${y}年${m}月${mark}`;
        }}
      />
    </div>
  );
};

export default CalendarWithMarks;
